import React, { Component } from "react";
import StatusPanel from "../shared/notices/StatusPanel";
import Tooltip from "../shared/Tooltip";
import Store from "../../content/Store";
import style from "../../assets/css/modules/claims/claims-summary-shortfall-row.css";

export default class ClaimsSummaryShortfallRow extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="pl-0 col-3 offset-1">
          <StatusPanel
            text={Store.Claims.PaymentNeededText}
            statusColour="red"
          />
        </div>
        <div className={style.claimsSummaryShortfall + " pl-0 col-8"}>
          <Tooltip
            text={Store.Claims.PaymentNeededTooltipText}
            customStyle="mt-2 pt-0"
          />
        </div>
      </React.Fragment>
    );
  }
}
